import React, { Component, Fragment } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Accordion } from 'react-accessible-accordion';
import ReactHtmlParser from 'react-html-parser';
import Glide from '@glidejs/glide';
import {
  Paragraph,
  Section,
  SectionHeader,
  Accordion as AccordionCustom,
} from 'components';
import { data } from './logic.js';
import './HowWeWork.scss';

class HowWeWork extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSlide: 0,
    };
  }

  componentDidMount() {
    this.glide = new Glide('.how-we-work__slider', {
      type: 'slider',
      startAt: 0,
      perView: 1,
      animationDuration: 300,
      gap: 0,
      dragThreshold: false,
      autoplay: 3000,
      classes: {
        activeNav: 'active',
      },
    });

    this.glide.on(['build.after', 'run.after'], () => {
      this.setState({ currentSlide: this.glide.index });
    });

    this.glide.mount();
  }

  renderItem = () =>
    data.map((item, index) => (
      <li
        key={`item_${item.title + index}`}
        className={'how-we-work__item glide__slide'}
      >
        <SectionHeader
          size={'small'}
          lineColor={'white'}
          color={'white'}
          descriptionColor={'white'}
          headingType={3}
          description={item.description}
          fixed
        >
          {item.title}
        </SectionHeader>
      </li>
    ));

  renderAccordion = () =>
    data.map((item, index) => (
      <Fragment key={`acordion_${item.title + index}`}>
        <AccordionCustom
          additionalClass={'accordion__slider-item hide-tablet hide-desktop'}
          id={'prototyping-team'}
          backgroundColor={'mine-shaft'}
          headline={item.title}
          description={ReactHtmlParser(item.description)}
          lineColor={'red'}
          fontColors={['white', 'white', 'white']}
          index={index + 1}
          expandFirst
        />
      </Fragment>
    ));

  renderTitle = () =>
    data.map((item, index) => (
      <li
        key={`tile_${item.title + index}`}
        className={`how-we-work__title glide__bullet ${
          this.state.currentSlide === index ? 'active' : ''
        }`}
        onClick={() => this.glide.go(`=${index}`)}
        role={'presentation'}
      >
        <Paragraph color={'red'} size={'medium'}>
          {item.title}
        </Paragraph>
      </li>
    ));

  renderNavBullets = () =>
    data.map((item, index) => (
      <button
        key={`button_${item.title + index}`}
        className={'how-we-work__bullet glide__bullet'}
        data-glide-dir={`=${index}`}
      />
    ));

  render() {
    return (
      <Section color={'mine-shaft'}>
        <SectionHeader
          size={'big'}
          lineColor={'red'}
          color={'white'}
          descriptionColor={'white'}
          headingType={2}
          description={
            'Our development teams will guide you through the entire process of building and applying machine learning models and deep neural networks:'
          }
          fixed
        >
          How we work
        </SectionHeader>
        <Accordion>{this.renderAccordion()}</Accordion>
        <div className={'how-we-work__slider glide hide-mobile'}>
          <Row>
            <Col sm={12} md={6}>
              <ol className={'how-we-work__list-nav'}>
                {this.glide && this.renderTitle()}
              </ol>
            </Col>
            <Col sm={12} md={6} className={'hide-mobile'}>
              <div data-glide-el={'track'} className={'glide__track'}>
                <ul className={'glide__slides'}>{this.renderItem()}</ul>
              </div>
              <div
                className={'how-we-work__nav glide__bullets'}
                data-glide-el={'controls[nav]'}
              >
                {this.renderNavBullets()}
              </div>
            </Col>
          </Row>
        </div>
      </Section>
    );
  }
}

export default HowWeWork;
